// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import MoneyCollectOutlinedSvg from "@fishx/icons-svg/es/asn/MoneyCollectOutlined";
import FishxIcon from '../components/FishxIcon';

var MoneyCollectOutlined = function MoneyCollectOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: MoneyCollectOutlinedSvg
  }));
};

MoneyCollectOutlined.displayName = 'MoneyCollectOutlined';
export default React.forwardRef(MoneyCollectOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/MoneyCollectOutlined.js
// module id = 3162
// module chunks = 0